import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPagekitComponent } from './simple-icons-pagekit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPagekitComponent ],
    exports:      [ SimpleIconsPagekitComponent ],
    bootstrap:    []
})
export class SimpleIconsPagekitModule {}
